export const isLargeScreen = () => {
    if (window.screen.width >= 1205) {
        return true;
    } else {
        return false;
    }
}